/* The Spinsterz — Priority Processing.
 * DPO validates and sends its own cart request without submitting the form,
 * then redirects from its success handler. Add the upsell synchronously at
 * send time, before that redirect. Never add on click or after success.
 */
(function () {
  'use strict';

  // Default to false when installing this asset by itself. This theme ships
  // disableAjaxCart: true in ajaxCart.init, so the legacy callback is retired.
  var LEGACY_UPSELL_REMOVED = true;
  var CHECKBOX_SELECTOR = '#chk_up1';
  var busy = false;
  var sawFormSubmit = false;

  function upsellVariantId() {
    var cb = document.querySelector(CHECKBOX_SELECTOR);
    if (!cb || !cb.checked || cb.disabled) return null;
    var id = parseInt(String(cb.value || '').trim(), 10);
    return id > 0 ? id : null;
  }

  function isCartAdd(url) {
    var target = new URL(String(url || ''), window.location.href);
    return target.origin === window.location.origin && /\/cart\/add(\.js)?$/.test(target.pathname);
  }

  function bodyMentionsVariant(body, id) {
    if (body == null || id == null) return false;
    var needle = String(id);
    try {
      if (typeof body === 'string') return body.indexOf(needle) !== -1;
      if (typeof FormData !== 'undefined' && body instanceof FormData && body.entries) {
        var it = body.entries();
        var entry = it.next();
        while (!entry.done) {
          if (String(entry.value[1]).indexOf(needle) !== -1) return true;
          entry = it.next();
        }
        return false;
      }
      if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) {
        return body.toString().indexOf(needle) !== -1;
      }
    } catch (err) {
      // Let the cart lookup handle an unreadable body.
    }
    return false;
  }

  function alreadyInCart(id) {
    try {
      var x = new XMLHttpRequest();
      x.open('GET', '/cart.js', false);
      x.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
      x.send(null);
      if (x.status !== 200) return false;
      var cart = JSON.parse(x.responseText);
      var items = (cart && cart.items) || [];
      for (var i = 0; i < items.length; i++) {
        if (Number(items[i].variant_id) === Number(id)) return true;
      }
    } catch (err) {
      // An upsell error must never block the customer's main add.
    }
    return false;
  }

  function postUpsell(id) {
    var x = new XMLHttpRequest();
    // Deliberately synchronous: DPO can navigate as soon as its add succeeds.
    x.open('POST', '/cart/add.js', false);
    x.setRequestHeader('Content-Type', 'application/json');
    x.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    x.send(JSON.stringify({ items: [{ id: id, quantity: 1 }] }));
    return x.status === 200;
  }

  function removeUpsell(id) {
    try {
      var x = new XMLHttpRequest();
      x.open('POST', '/cart/change.js', true);
      x.setRequestHeader('Content-Type', 'application/json');
      x.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
      x.send(JSON.stringify({ id: String(id), quantity: 0 }));
    } catch (err) {
      // A rollback error must not interfere with the original response.
    }
  }

  function addUpsellIfWanted() {
    if (busy || (!LEGACY_UPSELL_REMOVED && sawFormSubmit)) return null;
    busy = true;
    try {
      var id = upsellVariantId();
      if (id === null || alreadyInCart(id) || !postUpsell(id)) return null;
      try {
        document.dispatchEvent(new CustomEvent('skip-the-line:added', {
          detail: { variantId: id }
        }));
      } catch (err) {
        // Analytics must never change add-to-cart behavior.
      }
      return id;
    } catch (err) {
      return null;
    } finally {
      busy = false;
    }
  }

  function settle(id, ok) {
    if (id !== null && id !== undefined && !ok) removeUpsell(id);
  }

  try {
    document.addEventListener('submit', function (evt) {
      try {
        var form = evt.target;
        var action = form && form.getAttribute && form.getAttribute('action');
        if (action && action.indexOf('/cart/add') !== -1) sawFormSubmit = true;
      } catch (err) { /* Preserve form submission. */ }
    }, true);
  } catch (err) { /* Preserve native cart behavior. */ }

  try {
    var nativeOpen = XMLHttpRequest.prototype.open;
    var nativeSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (method, url) {
      try {
        this.__stlUrl = url;
        this.__stlMethod = String(method || '').toUpperCase();
      } catch (err) { /* Preserve the original request. */ }
      return nativeOpen.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function (body) {
      // Owned by THIS send call, never shared with another request.
      var addedId = null;
      try {
        if (this.__stlMethod === 'POST' && isCartAdd(this.__stlUrl) && !busy &&
            !bodyMentionsVariant(body, upsellVariantId())) {
          addedId = addUpsellIfWanted();
          if (addedId !== null) {
            var xhr = this;
            var settled = false;
            function finish(ok) {
              if (settled) return;
              settled = true;
              settle(addedId, ok);
            }
            xhr.addEventListener('load', function () {
              finish(xhr.status >= 200 && xhr.status < 300);
            });
            xhr.addEventListener('error', function () { finish(false); });
            xhr.addEventListener('abort', function () { finish(false); });
            xhr.addEventListener('timeout', function () { finish(false); });
          }
        }
      } catch (err) { /* Always send the main product request. */ }

      try {
        return nativeSend.apply(this, arguments);
      } catch (err) {
        settle(addedId, false);
        throw err;
      }
    };
  } catch (err) { /* Keep the available native cart transport. */ }

  try {
    var nativeFetch = window.fetch;
    if (typeof nativeFetch === 'function') {
      window.fetch = function (input, init) {
        // Only this particular request may roll back the line it added.
        var addedId = null;
        try {
          var url = typeof input === 'string' ? input : (input && input.url) || '';
          var method = String((init && init.method) || (input && input.method) || 'GET').toUpperCase();
          if (method === 'POST' && isCartAdd(url) && !busy &&
              !bodyMentionsVariant(init && init.body, upsellVariantId())) {
            addedId = addUpsellIfWanted();
          }
        } catch (err) { /* Always send the main product request. */ }

        var result;
        try {
          result = nativeFetch.apply(this, arguments);
        } catch (err) {
          settle(addedId, false);
          throw err;
        }
        if (addedId === null || !result || typeof result.then !== 'function') return result;
        return result.then(function (res) {
          settle(addedId, !!res && res.ok);
          return res;
        }, function (err) {
          settle(addedId, false);
          throw err;
        });
      };
    }
  } catch (err) { /* Keep the available native cart transport. */ }
})();
